import LegalPage from "../components/LegalPage";

export default function Affiliates() {
  return (
    <LegalPage
      eyebrow="Partner With Us"
      title="Affiliate Program"
      summary="Mystery Ranch partners with AvantLink to power our affiliate program. We expect our partners to be driven by a commitment to exceptional online experiences — from lifestyle blogs to YouTube channels."
      sections={[
        {
          id: "rates",
          title: "Commission Structure",
          dl: [
            { label: "Coupon / deal sites",   value: "2.5%" },
            { label: "Social media partners", value: "4%" },
            { label: "Editorial creators",    value: "5%" },
          ],
        },
        {
          id: "benefits",
          title: "Benefits",
          list: [
            "90-day cookie duration.",
            "Average order value over $300.",
            "Strong customer satisfaction and loyalty.",
            "Extensive backpack product line.",
            "Lifetime warranty against material and craftsmanship defects.",
          ],
        },
        {
          id: "apply",
          title: "How to Apply",
          list: [
            "Visit AvantLink's program page.",
            "Review the terms and complete the application.",
            "Post Mystery Ranch links on your platform.",
            "Monitor performance via AvantLink's tracking system.",
          ],
        },
        {
          id: "links",
          title: "Apply Now",
          links: [
            { label: "Mystery Ranch on AvantLink", href: "https://www.avantlink.com/programs/13570", external: true,
              note: "program page + application" },
          ],
        },
      ]}
      footer={
        <p>
          Questions? Reach our affiliate team via the {" "}
          <a href="/contact" style={{ color: "var(--color-ember-dark)", fontWeight: 700 }}>contact page</a>.
        </p>
      }
    />
  );
}
